import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsProgressButtonModule } from '@lcs/shared/progress-button';
import { CallStateModule } from 'src/app/call-state/call-state.module';
import { NdtLogoModule } from 'src/app/common-components/ndt-logo/ndt-logo.module';
import { UserPasswordResetRequestModule } from '../user-password-reset-request/user-password-reset-request.module';
import { LoginDialogComponent } from './dialog/login-dialog.component';
import { LoginViewComponent } from './views/login-view.component';
import { LoginComponent } from './views/login.component';

@NgModule({
   declarations: [LoginComponent, LoginViewComponent, LoginDialogComponent],
   exports: [LoginComponent, LoginViewComponent, LoginDialogComponent],
   imports: [
      CallStateModule,
      CommonModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsProgressButtonModule,
      ReactiveFormsModule,
      NdtLogoModule,
      MatFormFieldModule,
      MatInputModule,
      UserPasswordResetRequestModule,
      MatButtonModule,
   ],
})
export class LoginModule {}
